//#region src/kiosk_device_type.ts
var KioskDeviceType = /* @__PURE__ */ function(KioskDeviceType) {
	KioskDeviceType[KioskDeviceType["iPad"] = 1] = "iPad";
	KioskDeviceType[KioskDeviceType["iPadPro"] = 2] = "iPadPro";
	KioskDeviceType[KioskDeviceType["AndroidElo15"] = 3] = "AndroidElo15";
	KioskDeviceType[KioskDeviceType["AndroidElo22"] = 4] = "AndroidElo22";
	KioskDeviceType[KioskDeviceType["AndroidElo22Backpack"] = 5] = "AndroidElo22Backpack";
	KioskDeviceType[KioskDeviceType["AndroidElo32Backpack"] = 6] = "AndroidElo32Backpack";
	KioskDeviceType[KioskDeviceType["AndroidEloBackpackWorkspaceOne"] = 8] = "AndroidEloBackpackWorkspaceOne";
	KioskDeviceType[KioskDeviceType["AndroidElo22WorkspaceOne"] = 9] = "AndroidElo22WorkspaceOne";
	KioskDeviceType[KioskDeviceType["ChromeOsElo22"] = 10] = "ChromeOsElo22";
	KioskDeviceType[KioskDeviceType["ChromeOsElo15"] = 11] = "ChromeOsElo15";
	KioskDeviceType[KioskDeviceType["AndroidZebraET40"] = 50] = "AndroidZebraET40";
	KioskDeviceType[KioskDeviceType["AndroidLenovoK10"] = 100] = "AndroidLenovoK10";
	KioskDeviceType[KioskDeviceType["AndroidLenovoM90n"] = 110] = "AndroidLenovoM90n";
	KioskDeviceType[KioskDeviceType["AndroidHPEngagePro19_5"] = 150] = "AndroidHPEngagePro19_5";
	KioskDeviceType[KioskDeviceType["AndroidHPEngagePro24"] = 160] = "AndroidHPEngagePro24";
	KioskDeviceType[KioskDeviceType["AndroidSamsungGalaxyTabASeries"] = 170] = "AndroidSamsungGalaxyTabASeries";
	KioskDeviceType[KioskDeviceType["AndroidSamsungGalaxyTabActiveProSeries"] = 171] = "AndroidSamsungGalaxyTabActiveProSeries";
	KioskDeviceType[KioskDeviceType["AndroidSamsungGalaxyTabSSeries"] = 172] = "AndroidSamsungGalaxyTabSSeries";
	KioskDeviceType[KioskDeviceType["AndroidSunmi215"] = 200] = "AndroidSunmi215";
	KioskDeviceType[KioskDeviceType["AndroidMicroTouch22"] = 250] = "AndroidMicroTouch22";
	KioskDeviceType[KioskDeviceType["AndroidPosiflexMercury"] = 275] = "AndroidPosiflexMercury";
	KioskDeviceType[KioskDeviceType["AndroidPyramidFlex215"] = 300] = "AndroidPyramidFlex215";
	KioskDeviceType[KioskDeviceType["AndroidTouchDynamic"] = 305] = "AndroidTouchDynamic";
	KioskDeviceType[KioskDeviceType["AndroidFlytechAcrelec"] = 310] = "AndroidFlytechAcrelec";
	KioskDeviceType[KioskDeviceType["TizenSamsungKM24A"] = 350] = "TizenSamsungKM24A";
	KioskDeviceType[KioskDeviceType["ChromeOsSamsungKM24W"] = 351] = "ChromeOsSamsungKM24W";
	KioskDeviceType[KioskDeviceType["ChromeOsSamsungKM24ALenovoChromeBox"] = 352] = "ChromeOsSamsungKM24ALenovoChromeBox";
	KioskDeviceType[KioskDeviceType["AndroidSamsungKM24AFlytech"] = 353] = "AndroidSamsungKM24AFlytech";
	KioskDeviceType[KioskDeviceType["ChromeOsLenovoChromeBox"] = 361] = "ChromeOsLenovoChromeBox";
	KioskDeviceType[KioskDeviceType["ChromeOsLenovoM90n"] = 362] = "ChromeOsLenovoM90n";
	KioskDeviceType[KioskDeviceType["ChromeOsLG27KC3PK_C"] = 375] = "ChromeOsLG27KC3PK_C";
	KioskDeviceType[KioskDeviceType["ChromeOsHPEngagePro24"] = 400] = "ChromeOsHPEngagePro24";
	KioskDeviceType[KioskDeviceType["ChromeOsHPEngagePro19_5"] = 401] = "ChromeOsHPEngagePro19_5";
	KioskDeviceType[KioskDeviceType["ChromeOsAcrelecK22"] = 415] = "ChromeOsAcrelecK22";
	KioskDeviceType[KioskDeviceType["ChromeOsPosiflexMercury"] = 420] = "ChromeOsPosiflexMercury";
	KioskDeviceType[KioskDeviceType["ChromeOsTouchDynamicEdgeUltra22"] = 430] = "ChromeOsTouchDynamicEdgeUltra22";
	KioskDeviceType[KioskDeviceType["ChromeOsMicroTouch22"] = 440] = "ChromeOsMicroTouch22";
	KioskDeviceType[KioskDeviceType["ChromeOsPyramidPassport32"] = 450] = "ChromeOsPyramidPassport32";
	KioskDeviceType[KioskDeviceType["ChromeOsNcr7360"] = 460] = "ChromeOsNcr7360";
	return KioskDeviceType;
}(KioskDeviceType || {});
//#endregion
export { KioskDeviceType };

//# sourceMappingURL=kiosk_device_type.js.map